import React, { type PropsWithChildren } from "react";

import { type ColumnDef } from "@pages/sales/tab-table-section/table/table-utils";

import { type SubLevel } from "./types";

export const HeadComponent = ({
  adObjectLevel,
  columnConfigs,
  row,
  children,
}: PropsWithChildren<{
  adObjectLevel: SubLevel;
  columnConfigs: (
    | ColumnDef
    | { name: string; id: string; title: string; width: number }
  )[];
  row: { name: string; key: string; display: Record<string, unknown> };
}>) => (
  <thead className="dx-g-bs4-fixed-header dx-g-bs4-table-sticky">
    {children}
    <tr>
      <th className="table-summary-cell" scope="col">
        {adObjectLevel === "campaign" ? "Campaign total" : "Adset total"}
      </th>
      {columnConfigs
        .filter((e) => e.id !== "name")
        .map((e) => (
          <th key={e.id} className="table-summary-cell" scope="col">
            {row.display[e.id]}
          </th>
        ))}
    </tr>
  </thead>
);
